/* Megaprintery — 3D mock-up request: sheet delivery repair.
 *
 * Two faults this corrects:
 *
 * 1. The page script posts the request to Apps Script with mode:"no-cors".
 *    Google answers that exact request shape with 503 every time, while the
 *    same request in normal CORS mode returns 200 and writes the row. Because
 *    the call is opaque the page can never see the refusal, so the visitor is
 *    thanked and nothing arrives. The fetch wrapper below drops the no-cors
 *    flag on calls to the hook, which is all it takes.
 *
 * 2. The build sheet on a product page runs a different script that has no
 *    sheet code at all. The submit listener below sends that one itself, and
 *    stands down whenever the page has already sent the request.
 */
(function () {
  "use strict";

  var HOOK = "https://script.google.com/macros/s/AKfycbyDpVCjB0fpZyZyANjZKI7F-MHbh9QVY7xpHT4yR2BMLsyHtmePZCa1sreYlCGHVbkzYg/exec";
  var SECRET = "mp-3d-KcIbrLIHebE-2026";
  var QUIET = 8000;
  var lastSent = 0;

  function isHook(url) {
    return String(url || "").indexOf("script.google.com/macros/") > -1;
  }

  if (window.fetch) {
    var original = window.fetch;
    window.fetch = function (input, init) {
      try {
        var url = typeof input === "string" ? input : (input && input.url) || "";
        if (isHook(url)) {
          lastSent = Date.now();
          if (init && init.mode === "no-cors") {
            var next = {};
            for (var k in init) if (Object.prototype.hasOwnProperty.call(init, k)) next[k] = init[k];
            delete next.mode;
            delete next.credentials;
            init = next;
          }
        }
      } catch (err) {}
      return original.apply(this, arguments.length > 1 ? [input, init] : [input]);
    };
  }

  function payloadOf(form) {
    var out = { secret: SECRET };
    try {
      Array.prototype.forEach.call(form.elements, function (el) {
        var n = el.getAttribute && el.getAttribute("name");
        if (!n || n.indexOf("contact[") !== 0) return;
        if ((el.type === "checkbox" || el.type === "radio") && !el.checked) return;
        out[n] = el.value || "";
      });
    } catch (err) {}
    return out;
  }

  function send(form) {
    if (!window.fetch) return;
    lastSent = Date.now();
    try {
      window.fetch(HOOK, {
        method: "POST",
        headers: { "Content-Type": "text/plain;charset=utf-8" },
        body: JSON.stringify(payloadOf(form))
      }).catch(function () {});
    } catch (err) {}
  }

  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches("[data-mockup-form]")) return;
    window.setTimeout(function () {
      if (Date.now() - lastSent < QUIET) return;
      send(form);
    }, 60);
  }, true);
}());
